jQuery( document ).ready(function($) {

  if($('.codepartenaire').length > 0) {
    var code;
    $( ".codepartenaire-button" ).click(function(e) {
      e.preventDefault();
      code = $("#coupon_code").val();
      jQuery.post(
        my_ajax_object.ajax_url,
        {
          'action': 'get_products_coupon',
          'code': code,
        },
        function(response){
          if(response == 'fail') {
            $('.codepartenaire-empty').show();
          }
          else if(response == 'oneitem') {
            window.location.replace("/panier");
          }
          else {
            // console.log(response);
            $('.codepartenaire-form').hide();
            $('.codepartenaire-empty').hide();
            $('.codepartenaire-results').show();
            $('.codepartenaire-options').empty().append(response);
          }
        }
      );
    });

    $( ".codepartenaire-validate" ).click(function(e) {
      e.preventDefault();
      var product = $("#products").val();
      var description_code = $("#products").find(':selected').data('description');
      jQuery.post(
        my_ajax_object.ajax_url,
        {
          'action': 'add_product_coupon',
          'code': code,
          'product': product,
          'description_code': description_code,},
        function(){
          window.location.replace("/panier");
        }
      );
    });

  }
});

